module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.b73745d8.svg";